import { z } from "zod";

export const AwUserIdSchema = z.object({
	aw_user_id: z.string() // "1"
});

export type AwUserId = z.infer<typeof AwUserIdSchema>;
